import {React} from 'react';
import { BrowserRouter as Router, Routes as Switch, Route } from 'react-router-dom';
import "./styles.css";

import AppUrlListener from './components/widgets/AppUrlListener';

import {Start} from './components/pages/Start';
import {Login} from './components/pages/writer/Login';
import {Home} from './components/pages/writer/Home';
import {EditList} from './components/pages/writer/EditList';
import {GraphicList} from './components/pages/writer/GraphicList';
import {MarketingList} from './components/pages/writer/MarketingList';
import {PrintList} from './components/pages/writer/PrintList';
import {Providers} from './components/pages/Providers';
import {Provider} from './components/pages/Provider';
import {Reviews} from './components/pages/Reviews';
import {WriterProfile} from './components/pages/writer/WriterProfile';
import {EditWriterProfile} from './components/pages/writer/EditWriterProfile';
import {RegisterWriter} from './components/pages/writer/RegisterWriter';
import {VerifyEmail} from './components/pages/VerifyEmail';
import {WriterQuestionnaire} from './components/pages/writer/WriterQuestionnaire';
import {WriterListOfTasks} from './components/pages/writer/WriterListOfTasks';
import {ResetPassword} from './components/pages/writer/ResetPassword';


import {ProviderLogin} from './components/pages/provider/ProviderLogin';
import {RegisterProvider} from './components/pages/provider/RegisterProvider';
import {ProviderRequiredInfo} from './components/pages/provider/ProviderRequiredInfo';
import {ResetProviderPassword} from './components/pages/provider/ResetProviderPassword';
import {EditProviderProfile} from './components/pages/provider/EditProviderProfile';
import {EditProviderPackages} from './components/pages/provider/EditProviderPackages';
import {EditProviderPortfolio} from './components/pages/provider/EditProviderPortfolio';
import {EditProviderEducation} from './components/pages/provider/EditProviderEducation';
import {ProviderAnalytics} from './components/pages/provider/ProviderAnalytics';




import {DisplayLink} from './components/pages/DisplayLink'

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";

function App() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <>
      {/* <AppUrlListener></AppUrlListener> */}
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <Switch> 
          <Route path='/'>
            <Route path='/' element={<Start />} />
            <Route path='/start' element={<Start />} />
            <Route path='/login' element={<Login />} />
            <Route path='/home' element={<Home />} />
            <Route path='/edit-list' element={<EditList />} />
            <Route path='/graphic-list' element={<GraphicList />} />
            <Route path='/marketing-list' element={<MarketingList />} />
            <Route path='/print-list' element={<PrintList />} />
            <Route path='/providers/:subcategory' element={<Providers />} />
            <Route path='/providers/search/:search' element={<Providers />} />
            <Route path='/provider/:id?' element={<Provider />} />
            <Route path='/reviews/:id?' element={<Reviews />} />

            <Route path='/writer-profile' element={<WriterProfile />} />
            <Route path='/edit-writer-profile' element={<EditWriterProfile />} />
            <Route path='/register' element={<RegisterWriter />} />
            <Route path='/verify-email' element={<VerifyEmail />} />
            <Route path='/writer-questionnaire' element={<WriterQuestionnaire />} />
            <Route path='/writer-list-of-tasks' element={<WriterListOfTasks />} />
            <Route path='/reset-password' element={<ResetPassword />} />


            <Route path='/provider-login' element={<ProviderLogin />} />
            <Route path='/provider-register' element={<RegisterProvider />} />
            <Route path='/provider-required-info' element={<ProviderRequiredInfo />} />
            <Route path='/reset-provider-password' element={<ResetProviderPassword />} />

            <Route path='/edit-provider-questionnaire' element={<Provider />} />

            <Route path='/edit-provider-profile' element={<EditProviderProfile />} />
            <Route path='/edit-provider-packages' element={<EditProviderPackages />} />
            <Route path='/edit-provider-portfolio' element={<EditProviderPortfolio />} />
            <Route path='/edit-provider-education' element={<EditProviderEducation />} />

            <Route path='/provider-analytics' element={<ProviderAnalytics />} />


            



            
            


            {/* <Route path='/display-link' element={<DisplayLink />} /> */}
            <Route path='/login-provider' element={<Login />} />
          </Route>
        </Switch>
        <AppUrlListener></AppUrlListener>
      </Router>

    </>
  );
}

export default App;
